import {
  addDays,
  addMonths,
  addYears,
  startOfDay,
  endOfDay,
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
  isSameDay,
  differenceInCalendarDays,
} from 'date-fns';
import moment from 'moment-timezone';

const now = new Date()

const defineds = {
  startOfWeek: startOfWeek(now),
  endOfWeek: endOfWeek(now),
  startOfLastWeek: startOfWeek(addDays(now, -7)),
  endOfLastWeek: endOfWeek(addDays(now, -7)),
  startOfToday: startOfDay(now),
  endOfToday: endOfDay(now),
  startOfTomorrow: startOfDay(addDays(now, 1)),
  startOfYesterday: startOfDay(addDays(now, -1)),
  endOfYesterday: endOfDay(addDays(now, -1)),
  startOfMonth: startOfMonth(now),
  endOfMonth: endOfMonth(now),
  startOfLastMonth: startOfMonth(addMonths(now, -1)),
  endOfLastMonth: endOfMonth(addMonths(now, -1)),
  startOfSixMonthsAgo: addMonths(now, -6),
  startOfTwelveMonthsAgo: addMonths(now, -12),
};

const staticRangeHandler = {
  range: {},
  isSelected(range) {
    if (this.id !== 'custom') {
      const definedRange = this.range();
      if (
        isSameDay(range.startDate, definedRange.startDate) &&
        isSameDay(range.endDate, definedRange.endDate)
      ) {
        CustomRangeObject.startDate = range.startDate
        CustomRangeObject.endDate = range.endDate
        return true
      } else {
        return false
      }
    }

    for (let i = 0; i < DateRanges.length; i++) {
      if (DateRanges[i].id !== 'custom') {
        const definedRange = DateRanges[i].range();
        if (
          isSameDay(range.startDate, definedRange.startDate) &&
          isSameDay(range.endDate, definedRange.endDate)
        ) {
          CustomRangeObject.startDate = range.startDate
          CustomRangeObject.endDate = range.endDate
          return false
        }
      }
    }
    CustomRangeObject.startDate = range.startDate
    CustomRangeObject.endDate = range.endDate
    return true
  },
};

function createStaticRanges(ranges) {
  return ranges.map(range => ({ ...staticRangeHandler, ...range }));
}

export const CustomRangeObject = {
  startDate: null,
  endDate: null,
  id: 'custom',
  label: 'Custom'
}

export const DateRanges = createStaticRanges([
  {
    id: 'due',
    label: 'Due',
    range: () => ({
      startDate: null,
      endDate: defineds.endOfToday,
      id: 'due',
      label: 'Due',
    }),
  },
  {
    id: 'overdue',
    label: 'Overdue',
    range: () => ({
      startDate: null,
      endDate: defineds.endOfYesterday,
      id: 'overdue',
      label: 'Overdue',
    }),
  },
  {
    id: 'upcoming',
    label: 'Upcoming',
    range: () => ({
      startDate: defineds.startOfTomorrow,
      endDate: null,
      id: 'upcoming',
      label: 'Upcoming',
    }),
  },
  {
    id: 'next_7d',
    label: 'Next 7 days',
    range: () => ({
      startDate: startOfDay(addDays(now, 1)),
      endDate: endOfDay(addDays(now, 7)),
      id: 'next_7d',
      label: 'Next 7 days',
    }),
  },
  {
    id: 'today',
    label: 'Today',
    range: () => ({
      startDate: defineds.startOfToday,
      endDate: defineds.endOfToday,
      id: 'today',
      label: 'Today',
    }),
  },
  {
    id: 'yesterday',
    label: 'Yesterday',
    range: () => ({
      startDate: defineds.startOfYesterday,
      endDate: defineds.endOfYesterday,
      id: 'yesterday',
      label: 'Yesterday',
    }),
  },
  {
    id: 'this_week',
    label: 'This week',
    range: () => ({
      startDate: startOfWeek(now, { weekStartsOn: 1 }),
      endDate: defineds.endOfToday,
      id: 'this_week',
      label: 'This week',
    }),
  },
  {
    id: 'this_month',
    label: 'This month',
    range: () => ({
      startDate: startOfMonth(now),
      endDate: defineds.endOfToday,
      id: 'this_month',
      label: 'This month',
    }),
  },
  {
    id: 'last_7d',
    label: 'Last 7 days',
    range: () => ({
      startDate: startOfDay(addDays(now, -7)),
      endDate: defineds.endOfYesterday,
      id: 'last_7d',
      label: 'Last 7 days',
    }),
  },
  {
    id: 'last_30d',
    label: 'Last 30 days',
    range: () => ({
      startDate: startOfDay(addDays(now, -30)),
      endDate: defineds.endOfYesterday,
      id: 'last_30d',
      label: 'Last 30 days',
    }),
  },
  {
    id: 'last_90d',
    label: 'Last 90 days',
    range: () => ({
      startDate: startOfDay(addDays(now, -90)),
      endDate: defineds.endOfYesterday,
      id: 'last_90d',
      label: 'Last 90 days',
    }),
  },
  {
    id: 'last_6m',
    label: 'Last 6 months',
    range: () => ({
      startDate: defineds.startOfSixMonthsAgo,
      endDate: defineds.endOfYesterday,
      id: 'last_6m',
      label: 'Last 6 months',
    }),
  },
  {
    id: 'last_12m',
    label: 'Last 12 months',
    range: () => ({
      startDate: defineds.startOfTwelveMonthsAgo,
      endDate: defineds.endOfYesterday,
      id: 'last_12m',
      label: 'Last 12 months',
    }),
  },
  {
    id: 'current_7d',
    label: 'Current 7 days',
    range: () => ({
      startDate: addDays(now, -7),
      endDate: now,
      id: 'current_7d',
      label: 'Current 7 days',
    }),
  },
  {
    id: 'current_30d',
    label: 'Current 30 days',
    range: () => ({
      startDate: addDays(now, -30),
      endDate: now,
      id: 'current_30d',
      label: 'Current 30 days',
    }),
  },
  {
    id: 'current_90d',
    label: 'Current 90 days',
    range: () => ({
      startDate: addDays(now, -90),
      endDate: now,
      id: 'current_90d',
      label: 'Current 90 days',
    }),
  },
  {
    id: 'current_6m',
    label: 'Current 6 months',
    range: () => ({
      startDate: addMonths(now, -6),
      endDate: now,
      id: 'current_6m',
      label: 'Current 6 months',
    }),
  },
  {
    id: 'current_12m',
    label: 'Current 12 months',
    range: () => ({
      startDate: addMonths(now, -12),
      endDate: now,
      id: 'current_12m',
      label: 'Current 12 months',
    }),
  },
  {
    id: 'custom',
    label: 'Custom',
    range: () => CustomRangeObject
  },
  {
    id: 'all_time',
    label: 'Clear',
    range: () => ({
      startDate: null,
      endDate: null,
      id: 'all_time',
      label: '',
    }),
  },
]);
